
webpack.register(
    'modules/contact-us/contact-us',
    function() {
        return import('modules/contact-us/contact-us');
    },
    true
);